import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as filledHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';
import { ToastContainer, toast } from 'react-toastify';

import useToken from '../hooks/useToken';
import { SanitizedHTML } from '../utils/Helper';
import { API_ENDPOINTS } from '../utils/config';

import 'react-toastify/dist/ReactToastify.css';

// Toast settings reused across success/failure
const toastSettings = {
    position: 'bottom-left',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
};

const BlogList = ({ data: posts }) => {
    const { token } = useToken();
    const [likes, setLikes] = useState({});
    const [disabledButtons, setDisabledButtons] = useState({}); 

    const updateLikeCount = async ( postId, currentCount ) => { 
        const newCount = ( likes[postId] || currentCount ) + 1;
        setLikes( ( prev ) => ({ ...prev, [postId]: newCount }) );

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${token}`,
                },
            };

            const params = {
                liked_count: newCount,
                post_id: postId,
            };

            const { data: response } = await axios.put(
                `${API_ENDPOINTS.POSTS_ENDPOINT}/liked`,
                params,
                config
            );

            if ( response.status === 'success' ) {
                toast.success( response.message, toastSettings );
            } else {
                toast.error( response.message, toastSettings );
            }
        } catch (error) {
            console.error('Error updating like count:', error);
            toast.error('An error occurred while liking the post.', toastSettings);
        }
    };

    const handleLikeClick = (postId, index, currentCount) => {   
        if ( disabledButtons[postId] ) return;

        updateLikeCount( postId, currentCount );
        setDisabledButtons( ( prev ) => ({ ...prev, [postId]: true }) );
    };

    return (
        <>
            {posts?.map((post, index) => (
                <div className="box wow mb-5 pb-5 fadeInUp" key={post.id}>
                    <Row>
                        <Col className="col-lg-6 col-md-12 col-12 wow fadeInUp img-wrap">
                            <div className="post-image">
                                {post.featured_image && (
                                    <img
                                        src={post.featured_image}
                                        alt={post.title}
                                        className="img-fluid"
                                    />
                                )}
                                <span className="liked-count-wrap text-muted">
                                    <button
                                        onClick={() =>
                                        handleLikeClick(post.id, index, parseInt(post.liked_count))
                                        }
                                        disabled={disabledButtons[post.id]}
                                    >
                                        <FontAwesomeIcon
                                        icon={likes[post.id] ? filledHeart : regularHeart}
                                        />
                                    </button>
                                </span>                               
                            </div>
                            <div className="activity-wrp">
                                <div className="act-item">
                                    <SanitizedHTML html={post.page_views} tag="span" />
                                </div>
                                <div className="act-item">
                                    {likes[post.id] || <SanitizedHTML html={post.liked_count} tag="span" />}
                                </div>
                                <div className="act-item">
                                    <SanitizedHTML html={post.reading_time} tag="span" />
                                </div>
                                <div className="act-item">
                                    <SanitizedHTML html={post.comment_count} tag="span" />
                                </div>
                            </div>
                        </Col>
                        <Col className="col-lg-6 col-md-12 col-12 wow fadeInUp cont-wrap">
                            <ul className="cat-list">
                                {post.categories?.length > 0 &&                         
                                    post.categories.map((cat) => (
                                    <li key={cat.slug}>
                                        <Link className="text-muted" to={`/category/${cat.slug}`} >                                     
                                            <span className={cat.icon_class ? cat.icon_class : 'icon-blog' }></span>                                   
                                            {cat.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>            
                            <h2 className="text-start">
                                <Link className="text-dark" to={`/blog/${post.slug}`}>
                                    <SanitizedHTML html={post.title} tag="span" />
                                </Link>
                            </h2>                  
                            <ul className="post-meta up-txt d-flex ai-c mt-10 mt-7-sm">
                                <li className="d-flex">
                                    <Link to="/about-me" className="d-flex">
                                        {post.post_author_url && (
                                            <img
                                                src={post.post_author_url}
                                                alt={post.post_author_name}
                                                width={30}
                                                className="img-fluid rounded-circle me-2"
                                            />
                                        )}                                     
                                    </Link>
                                    <div className="name-wrp d-flex">
                                        <span className="prefix">By</span>
                                        <Link className="text-dark"to="/about-me">{post.post_author_name}</Link>
                                    </div>
                                </li>
                                <li className="d-flex"><span className="op-md">{post.post_date}</span></li>
                            </ul>                         
                            <p className="text-3">{post.excerpt}</p>
                            <div className="social_sharing">
                                <span className="readmore">
                                    <Link
                                        to={`/blog/${post.slug}`}
                                        className="d-flex align-items-center"
                                    >
                                        Read more
                                    </Link>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </div>
            ))}
            <ToastContainer />
        </>
    );
};

BlogList.propTypes = {
    data: PropTypes.arrayOf( PropTypes.object ).isRequired,
};

export default BlogList;